import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import ExplorePapers from "../explore/ExplorePapers";
import "./PersistentExploreLayout.css";

/**
 * PersistentExploreLayout - Twitter/Reddit Style Navigation for Explore Papers
 * 
 * This layout ensures the ExplorePapers component NEVER unmounts when navigating to paper details.
 * 
 * Architecture:
 * - ExplorePapers is ALWAYS rendered at full size
 * - When viewing paper detail (/explore/:doi), ExplorePapers is hidden via visibility:hidden
 * - PaperDetail renders on TOP via Outlet
 * - Scroll position is preserved because ExplorePapers dimensions don't change
 * 
 * Key Points:
 * - Tab state (For You, Trending, Search) is preserved
 * - Search query and results are preserved
 * - Pagination and filter states are preserved
 * - Saved papers view state is preserved
 * - Scroll position is maintained when returning from paper details
 */
const PersistentExploreLayout = () => {
  const location = useLocation();
  
  // Check if we're viewing a specific paper detail page
  // Match /explore/:doi pattern (where doi contains at least one character after /explore/)
  const isPaperDetailOpen = /^\/explore\/.+/.test(location.pathname);

  return (
    <div className="persistent-explore-layout">
      {/* PaperDetail renders FIRST (on top via z-index) */}
      {isPaperDetailOpen && (
        <div className="persistent-explore-layout__detail">
          <Outlet />
        </div>
      )}
      
      {/* ExplorePapers Container - ALWAYS MOUNTED at full size */}
      {/* visibility:hidden when paper detail is open, but dimensions preserved */}
      <div
        className={`persistent-explore-layout__list ${
          isPaperDetailOpen ? "persistent-explore-layout__list--hidden" : ""
        }`}
        aria-hidden={isPaperDetailOpen}
      >
        <ExplorePapers />
      </div>
    </div>
  );
};

export default PersistentExploreLayout;
